import { FC } from 'react';
import { EasyField } from 'react-bootstrap-formutil';
import FormGroup from 'components/FormGroup';
import QuestionnaireForm from 'components/forms/Questionnaire';
import { CustomerInfoKeyType } from 'types/customer';

interface QuestionnaireAnswerProps {
    disabled?: boolean;
}

export const defaultFieldsOfQuestionnaireAnswer: CustomerInfoKeyType[] = ['questionnaire_answer', 'is_professional'];

const QuestionnaireAnswer: FC<QuestionnaireAnswerProps> = ({ disabled }) => {
    return (
        <>
            <FormGroup
                name="questionnaire_answer"
                key="questionnaire_answer"
                className="hide-error"
                checker={value => {
                    if (value === 'required') {
                        return __('Please finish the questionnaire before continue');
                    }

                    if (value === 'disagree') {
                        return __('Please confirm and check the authenticity of the consent information');
                    }

                    return true;
                }}>
                <QuestionnaireForm disabled={disabled} />
            </FormGroup>
            {/* 给后端标识问卷版本使用 前端不改变值 直接传v2 */}
            <EasyField type="hidden" name="questionnaire_version" key="questionnaire_version" defaultValue="v2" />
            <EasyField type="hidden" name="is_professional" key="is_professional" defaultValue={0} />
        </>
    );
};

export default QuestionnaireAnswer;
